/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */


/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADVANCED SECTION - MESSAGE TO END-USERS : STYLES --------------- ++++++++++ */
export default theme => ({
  messagetoendusers: {
    '& a': { textDecoration: 'underline'},
    '& .name-clientMessage': {
      width: '100%',
      '& > div': {
        height: '220px'
      }
    },
    '& .messagetoenduserspreview': {
      width: '100%',
      '& > div': {
        background: '#fff !important',
        border: '2px solid #7B88BC',
        borderLeftWidth: '16px',
        borderRadius: '8px',
        marginTop: 0
      }
    }
  }
});
